// extracted by mini-css-extract-plugin
export var assigneeBadge = "_iw-0";
export var assigneeDetails = "_iw-1";
export var assigneeInfo = "_iw-2";
export var dropdownContainer = "_iw-4";
export var dropdownImage = "_iw-5";
export var editAssigneeInfo = "_iw-3";
export var editAssigneeModalContainer = "_iw-6";
export var hidden = "_iw-8";
export var input = "_iw-7";